/**
 * @generated SignedSource<<f3a4b4ed7601aace35c2653bcb912fb4>>
 * @relayHash 7603ffb5cdb0040c872fb1a866b28175
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0b1e2510061c030d99b8f44e327d161323fb6339bea4e158cd11ff183a6440a0

import type { ConcreteRequest, Query } from 'relay-runtime';
export type CommentAuthorUserQuery$variables = {
  id: string;
};
export type CommentAuthorUserQuery$data = {
  readonly user: {
    readonly displayName: string | null | undefined;
    readonly id: string | null | undefined;
    readonly photos: ReadonlyArray<{
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type CommentAuthorUserQuery = {
  response: CommentAuthorUserQuery$data;
  variables: CommentAuthorUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "displayName"
      },
      {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "value"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CommentAuthorUserQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentAuthorUserQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7603ffb5cdb0040c872fb1a866b28175",
    "id": "0b1e2510061c030d99b8f44e327d161323fb6339bea4e158cd11ff183a6440a0",
    "metadata": {},
    "name": "CommentAuthorUserQuery",
    "operationKind": "query",
    "text": "query CommentAuthorUserQuery($id:ID!){user:confluence_atlassianUser(id:$id){id,displayName,photos{value}}}"
  }
};
})();

(node as any).hash = "b941cc393296a840051106bc2b577a66";

export default node;
